import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '../../../../../node_modules/@angular/router';
import { Cotizacion } from '../cotizacion.model';

@Component({
  selector: 'app-cotizacion-edit',
  templateUrl: './cotizacion-edit.component.html',
  styleUrls: ['./cotizacion-edit.component.scss']
})
export class CotizacionEditComponent implements OnInit {

  cotizacion: Cotizacion;

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.data.subscribe( data => {
      this.cotizacion = data.cotizacion;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/cotizacion/cotizacion-edit/cotizacion-edit.component.ts